<template>
  <page-item :columnData="columnData" :orderType="12" :backName="backName"></page-item>
</template>

<script>
import PageItem from './components/PageItem'
export default {
  name: 'materialInReturned',
  components: {PageItem},
  data () {
    return {
      columnData: [{
        field: 'select',
        type: 'selection',
        width: '50'
      }, {
        field: 'operate',
        title: '操作',
        width: '120',
        isDefine: true,
        child: [{
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '日志',
          methodName: 'on-log',
          type: 'btn'
        }, {
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
          title: '详情',
          methodName: 'on-detail'
        }]
      }, {
        type: 'index',
        title: '序号',
        width: '60'
      }, {
        field: 'orderStatus',
        title: '单据状态',
        width: '150'
      }, {
        field: 'createTime',
        title: '编制日期',
        width: '120',
        formatter: ['toDateString', 'yyyy-MM-dd']
      }, {
        field: 'code',
        title: '单据编号',
        width: '180'
      }, {
        field: 'totalCost',
        title: '采购成本',
        width: '100'
      }, {
        field: 'businessName',
        title: '供应商',
        width: '180'
      }, {
        field: 'storehouseName',
        title: '仓库',
        width: '180'
      }, {
        field: 'remark',
        title: '备注',
        minWidth: '180'
      }],
      backName: '材料入库单列表'
    }
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/order/materialInReturned.vue